import router from '@/router';
import { resolveRoutes } from '@/router/utils';
import { getPrimaryType } from '@/utils';

export default {
    namespaced: true,
    state() {
        return {
            menus: []
        };
    },
    actions: {
        async initMenus({ commit, rootGetters }) {
            try {
                let menus = require(`@/router/routes.config`).default;
                if (getPrimaryType(menus) !== 'Array') menus = [menus];
                const routers = resolveRoutes(menus, rootGetters['user/permissions']);
                const initRedirect = function (items) {
                    items.forEach((item) => {
                        const children = item.children;
                        if (children) {
                            initRedirect(item.children);
                        }
                        if (item.redirect) {
                            children.forEach((child, index) => {
                                if (item.redirect === child.path) {
                                    return;
                                }
                                if (children.length - 1 === index && item.redirect !== child.path) {
                                    if(item.path === '/'){
                                        return;
                                    }
                                    item.redirect = children[0].path;
                                }
                            });
                        }
                    });
                };
                initRedirect(routers);
                router.addRoutes([...routers]);
                commit('setMenus', routers);
                return routers;
            } catch (error) {
                console.log(error);
            }
        }
    },
    mutations: {
        setMenus(state, data) {
            state.menus = data;
        }
    }
};
